let menu_heading_activated = false;
let menu_father_saved = null;

function showMenu(menu_father) {
    hiddeMenuChildrens(menu_father_saved);
    menu_father_saved = menu_father.children[1];
    showMenuChildrens(menu_father);
}

function showMenuChildrens(menu_father) {
    menu_father.childNodes.forEach(child => {
        if(child.tagName == "UL"){
          child.style.display = "flex"
        }
        else if(child.tagName == "DIV") {
            child.style.display = "flex";
            if(child.firstElementChild != null){
                if(child.firstElementChild.children.length == 0){
                    child.firstElementChild.style.display = "none";
                }
            }
            else {
                if(!child.classList.contains('menu-image')){
                    child.style.display = "none";
                }
            }
        }
        showMenuChildrens(child, null);
    });
}

function hiddeMenuChildrens(menu_father) {
    if(menu_father != null)
        menu_father.style.display = "none";
}

function fixMenuSizeMobile () {
    if ( document.body.clientWidth < 1151) {     
        let header_icons = document.getElementsByClassName("header__icons");
        if(header_icons[0] != null){
            header_icons[0].style.display = "none";
        }
    }
    else {
        let header_icons = document.getElementsByClassName("header__icons");
        if(header_icons[0] != null){
            header_icons[0].style.display = "flex";
        }      
    }
}

var menuIsOpen = true;

function closeSecondaryMenu() {
    var menu = document.getElementById("nav-2");
    if(menuIsOpen) {
        menu.style.animation = "hiddeMenu 5s forwards";
        menuIsOpen = !menuIsOpen;
    }
    else {
        menu.style.animation = "showMenu 1s forwards";
        menuIsOpen = !menuIsOpen;
    }
}

window.addEventListener("resize", fixMenuSizeMobile);
window.addEventListener("DOMContentLoaded", fixMenuSizeMobile);